module.exports = __webpack_public_path__ + "static/media/upload.4e4d22b0.svg";